// @ts-nocheck
import { Rect, State, Modifier } from '@popperjs/core';

/**
 * Utility function that finds the closest ancestor by specific selector. Used with {@link popperMatchHeaderWidth} modifier.
 * @param element Starting element
 * @param selector Selector to search for as we traverse the DOM tree. (e.g., .lmig-FloatingHeader-inner)
 * @returns element
 */
export const findAncestor = (element: Element, selector: string): Element => {
  return element && element.closest(selector);
};

/**
 * Custom function to ensure proper alignment of `ParentItemDropdown` to the inner floating header div
 * We use the popper offset that is defined in {@link popperMatchHeaderWidth} - the reference element offset {@link ParentItemDropdown}
 * @returns [xOffset, yOffset]
 */
export const popperCustomOffset = ({ reference, popper }: { reference: Rect; popper: Rect }): [number, number] => {
  const { x: refX } = reference;
  const { x: popX } = popper;
  // for now, the only placement is bottom. If we expand those options, we'll have to create conditions here.
  return [Math.round(popX - refX), 1];
};

export const popperMatchHeaderWidth: Partial<Modifier<string, object>> = {
  name: 'popperMatchHeaderWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ state }: { state: State }): void => {
    const { reference } = state.elements;
    const header = findAncestor(reference as Element, '.lmig-FloatingHeader-inner');
    const { width, left, height } = header.getBoundingClientRect();
    // eslint-disable-next-line no-param-reassign
    state.styles.popper = {
      ...state.styles.popper,
      width: `${width}px`,
      left: `${Math.round(left)}px`,
      transform: `translate3d(${Math.round(left) * -1}px, ${height}px, 0)`,
    };
  },
};
